import { ContinueButton } from './common.jsx';

// Neurotoxicity symptom scale — graduated circles labeled Never..Always. No numbers
// shown, no default (must actively pick); stored 0-4 for server-side scoring.
const WORDS = ['Never', 'Rarely', 'Sometimes', 'Often', 'Always'];
const SIZE = [22, 26, 30, 34, 38];

export default function Scale({ screen, answers, setAnswer, onAdvance }) {
  const { items } = screen;
  // Every symptom is required — the score is a sum, so a skipped row silently lowers it.
  const unanswered = items.filter((it) => answers[it.id] === undefined).length;

  return (
    <>
      <h1>How often do you experience each?</h1>
      <p className="scalehead">Tap a rating for each — {items.length} on this screen.</p>
      {items.map((it) => {
        const cur = answers[it.id];
        return (
          <div className="scalerow" key={it.id}>
            <div className="lab">{it.label}</div>
            <div className={`optrow${cur !== undefined ? ' answered' : ''}`}>
              {WORDS.map((w, v) => (
                <div
                  key={v}
                  className={`opt${cur === v ? ' sel' : ''}`}
                  onClick={() => setAnswer(it.id, v)}
                  role="button"
                  aria-label={w}
                >
                  <div className="dotcell">
                    <div className="dot" style={{ width: SIZE[v], height: SIZE[v] }}>
                      {cur === v ? '✓' : ''}
                    </div>
                  </div>
                  <div className="w">{w}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      {unanswered > 0 && (
        <p className="reqnote">Please rate all {items.length} — {unanswered} still to go.</p>
      )}
      <div className="spacer" style={{ height: 22 }} />
      <ContinueButton onClick={onAdvance} disabled={unanswered > 0} />
    </>
  );
}
